/**
 * 외부회원 관리 (/adm/outer/members)
 * ($j.Pages.Admin.OutMember / body data-page-name="OutMember")
 *
 * 비회원 기사(g5_out_members) 목록 + 편집·삭제. 편집 모달은 공유 모듈 $j.F.Admin.OutMember.EditForm,
 * 차종 마스터는 #om-data(EditForm._data()) 하나를 같이 읽는다.
 */
export default class OutMember {
    initialize() { initialize(); }
}

let $table = null;
// 편집 모달은 공유 모듈($j.F.Admin.OutMember.EditForm)로 이관 — 저장 성공 시 목록 새로고침
const omReload = () => { if ($table) $table.ajax.reload(null, false); };

function initialize() {
    loadTable();
    bindAutoComplete();

    // 오더검색과 동일 — 셀렉트 변경만으로는 조회하지 않고, 조건을 다 고른 뒤 검색버튼/엔터로 한번에 반영
    $('#searchBtn').click(function () { $table.ajax.reload(); });
    $('#kwd').on('keypress', function (e) { if (e.which === 13) $table.ajax.reload(); });
    // 셀렉트에서 엔터로도 검색되게 (포커스가 셀렉트에 있을 때)
    $('#searchcartype, #is_agree, #is_card, #work_term').on('keypress', function (e) { if (e.which === 13) $table.ajax.reload(); });
    $('#resetBtn').click(function () {
        $('#searchcartype, #is_agree, #is_card, #work_term').val('');
        $('#kwd').val('').trigger('input');// x 버튼도 함께 숨김
        renderOptTags();             // 옵션 태그도 닫기
        $('#pageLen').val('30');
        $table.page.len(30).draw();   // 필터 비운 채 재조회
    });

    // 차종 변경 → 옵션 태그 다시 그리기 (조회는 검색버튼으로)
    $('#searchcartype').on('change', renderOptTags);
    $('#optTags').on('click', '.ftag', function () { $(this).toggleClass('on'); });
    $('#addBtn').click(function () { $j.F.Admin.OutMember.EditForm.open(null, { onSaved: omReload }); });
    // 페이지당 건수
    $('#pageLen').on('change', function () { $table.page.len(parseInt(this.value, 10)).draw(); });
}

/**
 * 통합검색칸 자동완성 — 악덕·회원 검색과 동일한 공용 위젯을 외부회원에 붙인다.
 * 목록검색과 같은 조건식을 타므로 "자동완성엔 떴는데 검색하면 없다"가 생기지 않는다.
 * 이미 고른 차종은 params 로 함께 넘겨 후보를 목록 결과와 맞춘다.
 *
 * 후보는 이름·연락처만 본다 — 지역은 서버에서 제외한다. '경기'처럼 지역을 치면
 * 고를 것도 없는 목록이 뜨면서 화면만 가리기 때문. 지역 검색은 검색버튼으로 한다.
 */
function bindAutoComplete() {
    const esc = (s) => $('<div>').text(s == null ? '' : s).html();
    const params = () => ({
        searchcartype: $('#searchcartype').val() || '',
    });

    // 검색칸 지우기(x) — 값이 있을 때만 보인다.
    // autocomplete() 가 input 을 .ac-wrap 으로 감싼 뒤라야 그 안에 얹을 수 있다.
    const addClear = ($in) => {
        $in.addClass('has-clear');
        const $btn = $('<button type="button" class="fi-clear" title="지우기">&times;</button>')
            .appendTo($in.parent());
        const sync = () => $btn.toggleClass('on', $in.val().trim() !== '');
        $in.on('input change', sync);
        $btn.on('mousedown', (e) => e.preventDefault())   // 입력칸 blur 방지
            .on('click', () => {
                $in.val('').trigger('input').focus();
                $table.ajax.reload();
            });
        sync();
        return sync;
    };

    let syncClear = () => {};   // 아래 addClear() 가 채운다 (감싼 뒤라야 붙일 수 있어서 순서가 늦다)

    // 고르면 '이름#번호' 로 확정한다 — 접수목록 발주자칸과 같은 규약.
    // 동명이인이 섞이지 않고, 인풋에 보이는 텍스트가 그대로 검색기준이라 숨은 상태가 없다.
    $j.F.Admin.Util.autocomplete($('#kwd'), {
        url: '/adm/ajax/outer/members/autocomplete',
        params: params,
        render: (r) => `<b>${esc(r.name)}</b>`
            + `<span class="om-ac-phone"> ${esc(r.phone)}</span>`
            + `<span class="om-ac-meta"> ${esc(r.car_type)} ${esc(r.sido)}</span>`,
        // ⚠️ 여기서 trigger('input') 을 쏘면 안 된다. 위젯이 방금 넣은 '이름#번호' 를
        //    새 검색어로 보고 다시 조회해 드롭다운이 되살아난다(choose() 가 pick 직전에
        //    옛 입력값으로 last 를 잡기 때문). x버튼 표시만 필요하므로 직접 부른다.
        pick: (r) => { $('#kwd').val(r.name + '#' + r.num); syncClear(); $table.ajax.reload(); },
    });

    // autocomplete() 가 .ac-wrap 으로 감싼 뒤에 붙인다
    syncClear = addClear($('#kwd'));
}

/**
 * 차종에 해당하는 옵션 태그 렌더 (편집모달과 같은 #om-data 의 carOptions).
 * 차종 미선택이거나 옵션이 없는 차종이면 태그와 라벨을 감춘다.
 */
function renderOptTags() {
    const carType = $('#searchcartype').val();
    const list = ($j.F.Admin.OutMember.EditForm._data().carOptions || {})[carType] || [];

    if (!carType || !list.length) {
        $('#optTags').empty();
        $('#optTagLabel').hide();
        return;
    }
    const html = list.map(function (v) {
        const s = String(v).replace(/"/g, '&quot;');
        return '<span class="ftag" data-v="' + s + '">' + s + '</span>';
    }).join('');
    $('#optTags').html(html);
    $('#optTagLabel').show();
}

/** 선택된 옵션 태그 → 콤마 문자열 */
function selectedOptions() {
    return $('#optTags .ftag.on').map(function () { return $(this).attr('data-v'); }).get().join(',');
}

function loadTable() {
    // ⚠ 글자 칸(연락처·옵션·지역·메모)에는 width 를 주지 않는다.
    // 고정폭을 주면 창이 좁아져도 그 칸이 안 줄어 표가 990px 아래로 못 내려가고 잘렸다.
    // 짧고 폭이 일정한 칸에만 width 를 남겨 비율을 잡는다.
    const columns = [
        {data: 'rownum',         title: '번호',     width: '40px'},
        {data: 'car_type_badge', title: '차종',     width: '60px'},
        {data: 'name',           title: '이름',     width: '60px',  className: 'name'},
        {data: 'phone',          title: '연락처',   className: 'phone'},
        {data: 'car_spec',       title: '규격',     width: '55px',  orderable: false},
        {data: 'car_option',     title: '옵션',     className: 'wrap'},
        {data: 'car_height',     title: '높이',     width: '45px'},
        {data: 'sido',           title: '지역',     className: 'sido wrap'},
        {data: 'work_day_str',   title: '최근작업', width: '70px'},
        {data: 'memo',           title: '메모',     orderable: false, className: 'wrap'},
        {data: 'created_str',    title: '생성일',   width: '62px'},
        {data: 'updated_str',    title: '수정일',   width: '62px'},
        {data: 'agree_str',      title: '동의',     width: '52px'},
        {data: 'card_str',       title: '카드',     width: '52px'},
        {data: 'manager_name',   title: '관리자',   width: '65px'},
        {
            data: null, title: '', width: '90px', orderable: false,
            render: function (data) {
                return '<button class="edit-btn" data-num="' + data.num + '">편집</button>'
                     + '<button class="del-btn" data-num="' + data.num + '">삭제</button>';
            }
        }
    ];

    $table = new DataTable('#out-member-table', {
        autoWidth: false,
        columns: columns,
        order: [[8, 'desc']],            // 최근작업일 내림차순
        rowCallback: function (row, data) {
            if (parseInt(data.is_agree) === 2) $(row).addClass('om-disagree');  // 동의안함 → 빨간 줄 (색은 CSS 토큰)
        },
        // scrollX 를 쓰지 않는다 — 켜면 DataTables 가 표 폭을 픽셀로 못 박아
        // 창이 좁아져도 칸이 안 줄고 오른쪽이 잘린다. 넘칠 때만 .table-responsive 가 스크롤한다
        // (관리자 표 공통 규약 — /adm/account/list 와 같은 방식).
        // 하단 = 좌 건수 · 우 페이지번호 (관리자 표 공통 규약)
        layout: { topStart: null, topEnd: null, bottomStart: 'info', bottomEnd: 'paging' },
        ajax: {
            url: '/adm/ajax/outer/members/list',
            type: 'post',
            data: function (d) {
                d.searchcartype = $('#searchcartype').val();
                d.is_agree      = $('#is_agree').val();
                d.is_card       = $('#is_card').val();
                d.work_term     = $('#work_term').val();
                d.car_option    = selectedOptions();
                d.kwd           = $('#kwd').val();
            }
        },
        language: {
            emptyTable:     "데이터가 없습니다.",
            loadingRecords: "로딩 중...",
            zeroRecords:    "일치하는 결과가 없습니다.",
            paginate: {previous: "‹", next: "›"}
        },
        processing: true,
        serverSide: true,
        ordering: true,
        pageLength: 30,
        lengthChange: false,
        searching: false
    });

    // 편집 열기 — 편집 버튼 + 이름·연락처 칸. 목록에서 가장 먼저 눈이 가는 두 칸이라
    // 버튼까지 오른쪽 끝으로 가지 않아도 열리게 한다(누를 수 있다는 표시는 .om-clickable 이 준다).
    $('#out-member-table').on('click', '.edit-btn, td.name, td.phone', function () {
        var data = $table.row($(this).closest('tr')).data();
        $j.F.Admin.OutMember.EditForm.open(data, { onSaved: omReload });
    });

    // 삭제 — 행을 지우지 않고 목록에서만 감춘다(서버가 deleted_at·삭제자 기록).
    // 같은 연락처는 삭제 후 다시 등록할 수 있다 — 서버가 그 행을 되살려 쓴다.
    $('#out-member-table').on('click', '.del-btn', function () {
        var data = $table.row($(this).closest('tr')).data();
        $j.Ui.Dialog.open({
            tone:  'danger',
            title: '삭제하시겠습니까?',
            html: '<b>' + $('<div>').text(data.name || '').html() + '</b> '
                + $('<div>').text(data.phone || '').html()
                + '<br><span class="om-del-note">목록에서 사라지며, 같은 번호를 다시 등록할 수 있게 됩니다.</span>',
            confirm: '삭제',
            cancel:  '취소',
        }).then(function (ok) {
            if (!ok) return;
            $.post('/adm/ajax/outer/members/delete', { num: data.num }, function (res) {
                if (res && res.result === 'ok') {
                    $j.Ui.Toast.show('삭제완료', { type: 'success' });
                    omReload();
                } else {
                    $j.Ui.Dialog.open({ tone: 'danger', title: '삭제 실패', desc: (res && res.message) || '' });
                }
            }, 'json').fail(function () {
                $j.Ui.Dialog.open({ tone: 'danger', title: '오류', desc: '삭제 중 오류가 발생했습니다.' });
            });
        });
    });
}
